import { Stack, TextInput } from "@mantine/core";
import { useAuth } from "../../context/useAuth";
import { ACCOUNT_COPY } from "../../constants/account";
import { DeleteAccountCard } from "../../components/profile/DeleteAccountCard";
import { ContentCard, PageHeader } from "../../components/ui";
import { axioTokens } from "../../theme";

export function AccountSettingsPage() {
  const { user } = useAuth();

  return (
    <Stack gap={axioTokens.unit[40]} maw="var(--axio-unit-640)">
      <PageHeader title={ACCOUNT_COPY.pageTitle} subtitle={ACCOUNT_COPY.pageSubtitle} />
      <ContentCard>
        <Stack gap="md">
          <TextInput label="Full name" value={user?.full_name ?? ""} readOnly />
          <TextInput label="Email" value={user?.email ?? ""} readOnly />
        </Stack>
      </ContentCard>
      <DeleteAccountCard />
    </Stack>
  );
}
